import api from '@/utils/interceptor'

// 缓存版本查询
export const getLocalVersion = params => {
  return api.get('/mgr/fe/version', params)
}

//登录
export const login = params => {
  return api.get('/access/ui/FRONT-COMM/do/GTCPSPLOGIN040', params)
}
//登录获取头像
export const getUserImage = () => {
  return api.get('/access/ui/FRONT-COMM/do/GTCPSPUSER070')
}

//退出登录
export const loginOut = () => {
  return api.get('/access/ui/GTCPSP-FRONT/do/GTCPSPLOGIN020')
}

//获取公钥
export const getEncryptKey = params => {
  return api.post('/access/ui/FRONT-COMM/FRONTCOMMCRYPT010', params)
}

// 获取聊天客户端页面地址
export const getOnlineChatUrl = systemType => {
  return api.post('/access/ui/FRONT-COMM/GTCPSPCMSARTICLESERVICE004', {
    siteid: 'webportals',
    catalogid: `${systemType}Robot`,
  })
}

// 帮助中心模糊检索
export const helpCenterSearch = params => {
  return api.post('/access/ui/GTCPSP-FRONT/GTCPSPCMSARTICLESERVICE004', params)
}
// 帮助中心模糊检索
export const helpCenterSearchS = params => {
  return api.post('/access/ui/GTCPSP-FRONT/GTCPSPCMSARTICLESERVICE013', params)
}
// 数源查询
export const querySource = params => {
  return api.post('/dms/fe/portraitQuery/consumerQuery', params)
}

// 查询服务商信息
export const getServiceProvider = params => {
  return api.post('/ua/fe/cbm/queryServicesToPortal', params)
}

// 查询服务商详情信息
export const getCbmDetailByClassify = params => {
  return api.post('/ua/fe/cbm/detailByClassify', params)
}

// 查询服务项目列表
export const getServiceAbilityReleaseList = params => {
  return api.post('/tb/fe/serviceAbilityRelease/pageToPortal', params)
}

// 服务商综合反馈评价
export const getServiceEvaluation = params => {
  return api.post('/bi/fe/suyuan/chanye/overview', params)
}

// 查询需求一览
export const getDemand = p => {
  return api.post(`/bi/fe/suyuan/chanye/${p.url}`, p.params)
}
// 查询需求一览详情
export const getDemandDetails = params => {
  return api.get(`/bi/fe/suyuan/chanye/detail/${params}`)
}
// 查询服务一览
export const getService = params => {
  return api.post('/tb/fe/serviceAbilityRelease/queryInfoToPortal', params)
}
// 查询服务一览详情
export const getServiceDetails = params => {
  return api.post('/tb/fe/serviceAbilityRelease/portalDetail', params)
}

// 首页轮播图
export const homeBanner = params => {
  return api.post('/access/ui/GTCPSP-FRONT/GTCPSPCMSARTICLESERVICE006', params)
}

// 数源资讯
export const getInformation = catalogid => {
  return api.post('/access/ui/GTCPSP-FRONT/GTCPSPCMSARTICLESERVICE004', {
    siteid: 'webportals',
    pageParam: { firstRow: 0, pageNo: 1, rowsPerPage: 3 },
    catalogid,
  })
}
// 背景图
export const bannerList = params => {
  return api.post('/access/ui/GTCPSP-FRONT/GTCPSPCMSARTICLESERVICE004', {
    siteid: 'webportals',
    pageParam: { firstRow: 0, pageNo: 1, rowsPerPage: 1 },
    ...params,
  })
}
// 背景图
export const bannerListTwo = params => {
  return api.post('/access/ui/GTCPSP-FRONT/GTCPSPCMSARTICLESERVICE005', {
    ...params,
  })
}

// 数源应用案例
export const getApplicationCase = catalogid => {
  return api.post('/access/ui/GTCPSP-FRONT/GTCPSPCMSARTICLESERVICE004', {
    siteid: 'webportals',
    pageParam: { firstRow: 0, pageNo: 1, rowsPerPage: 10 },
    catalogid,
  })
}

// 最新发布的需求 - 以企业为单位显示
export const releaseRequirements = params => {
  return api.get(`/bi/fe/suyuan/chanye/${params.url}`)
}

// 企业编码查对应的服务范围
export const getEnterprise = params => {
  return api.post('/access/ui/GTCPSP-FRONT/GTCPSPCCODEDATA040', params)
}
//关键词查询
export const getKeyWord = params => {
  return api.post('access/ui/FRONT-COMM/GTCPSPCMSARTICLESERVICE012', params)
}
//是否推荐
export const getRecommendflag = params => {
  return api.post('access/ui/FRONT-COMM/GTCPSPCMSARTICLESERVICE011', params)
}

// 获取码表
export const getCodeTableList = params => {
  return api.post('/mgr/fe/codeTable/page', params)
}
